import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full mb-5" }
const _hoisted_2 = { class: "font-bold min-w-130 xl:min-w-160" }

import { withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileInfoItem',
  props: {
    title: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dl", _hoisted_1, [
    _createElementVNode("dt", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("dd", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})